export const createEl = () => {
  const el = document.createElement("div")
  return document.body.appendChild(el)
}

export const createBackground = (el) => {
  const background = document.createElement("div")
  const { style } = background
  style.position = "fixed"
  style.top = "0px"
  style.right = "0px"
  style.bottom = "0px"
  style.left = "0px"
  style.zIndex = "21"
  style.background = "rgba(0, 0, 0, 0.6)"
  el.parentNode.insertBefore(background, el)

  return background
}

export const hasOwnProperties = (props, obj) =>
  props.every((p) => Object.hasOwnProperty.call(obj, p))
